import React from "react"
import SettingsIntermediate from "../SettingsIntermediate"
import userPermissions from "../../User/Permissions"
import { getSession } from "../../../auth"
import { Box, Alert } from "@mui/material"
import Audit from "../../Settings/Users/Audit"

const AuditPage = () => {
    const groups = userPermissions()
    const enterprise = getSession()?.profile?.enterprise
    return (
        <>
            {/* {true 
                ?  */}
                <SettingsIntermediate title="Auditoria" components={() => ({
                        comp1: {
                            permissions: true,
                            style:"title",
                            label:"Auditoria"
                        },
                        comp2: {
                            permissions: groups.isAdmin, //&& enterprise.has_audit,
                            style:"list",
                            label:"Trilha de auditoria",
                            sublabel: "Verificar ações da sua equipe dentro do sistema.",
                            redirect: (<Audit />)
                        }
                    })
                } />
                 {/* : <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                     <Box sx={{ fontSize: "1.5em", fontWeight: "bold", color: "#21446c" }}>Auditoria</Box>
                     <Alert severity="info">
                         Entre em contato com seu gerente de contas para contratar a Trilha de Auditoria Kwik <a href="https://wa.link/0bs73j">Clique aqui.</a>
                     </Alert>
                 </Box>
             } */}
        </>
    )
}


export default AuditPage
